// @flow
import cond from 'ramda/es/cond';
import T from 'ramda/es/T';
import always from 'ramda/es/always';
import equals from 'ramda/es/equals';

import i18n from 'app/i18n';
import action from 'app/common/lib/action';
import api from 'app/actions/api';
import { fetchStudentsForce } from 'app/actions/students';
import { errorCode } from 'app/common/lib/error';

/**
 * Добавление ребенка.
 * (Не отражается в редюсере, кроме ошибок)
 */

export type Fields = {
  first_name: string,
  account_number: string,
  birthdate: string,
  card_number: string,
}

export const ADD_CHILD_REQUEST = 'ADD_CHILD_REQUEST';
export const ADD_CHILD_SUCCESS = 'ADD_CHILD_SUCCESS';
export const ADD_CHILD_FAILURE = 'ADD_CHILD_FAILURE';

export const addChild = (fields: Fields) =>
  async (dispatch: Function, getState: Function): Promise<*> => {
    const data: Fields = { ...fields };
    dispatch(action(ADD_CHILD_REQUEST, data));
    try {
      await api('cabinet/students/add', 'post', { data });
      dispatch(action(ADD_CHILD_SUCCESS, data));
      dispatch(fetchStudentsForce());
      return '';
    } catch (error) {
      const code: number = errorCode(error);
      const state = getState();
      const dealerText = (state.dealer.phone
        ? i18n.t('app:request_dealer_text', { phone: state.dealer.phone })
        : ''
      );
      const text: string = cond([
        [equals(404), always(i18n.t('app:request_children_not_found', { dealerText }))],
        [T, always(i18n.t('request_children_add_failed', { dealerText }))],
      ])(code);

      dispatch(action(
        ADD_CHILD_FAILURE, {
          err: text,
          error,
        }
      ));
      return text;
    }
  };
